import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { Link, Text } from "@sitecore-jss/sitecore-jss-react";
import React, { Fragment, useEffect, useState } from "react";
import { AuthenticationState } from "react-aad-msal";
import { scLinkType, scStringType } from "../../types";
import { rewardsDuck } from "../../ducks/rewards";
import { connect } from "react-redux";
import BonusRewardCard from "../bonusRewards/BonusRewardCard";
import MediaQuery from "react-responsive";
import Carousel from "../carousel/Carousel";
import { getLoyaltyStorage } from "../../util";
import { LoyaltyAccountStatus } from "../../util/LoyaltyAccountStatus";
import { getSessionStorageKey } from "../../util/sessionStorage";
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useLDClient } from 'launchdarkly-react-client-sdk';
var rewardsOperations = rewardsDuck.operations;

var JustForYouListing = function JustForYouListing(props) {
  var _ref = props || {},
      authenticationState = _ref.authenticationState,
      fields = _ref.fields,
      _ref$getBonusRewards = _ref.getBonusRewards,
      getBonusRewards = _ref$getBonusRewards === void 0 ? function () {} : _ref$getBonusRewards,
      _ref$getBonusRewardsA = _ref.getBonusRewardsAccountInfo,
      getBonusRewardsAccountInfo = _ref$getBonusRewardsA === void 0 ? function () {} : _ref$getBonusRewardsA,
      accountInfo = _ref.accountInfo;

  var _ref2 = fields || {},
      Header = _ref2.Header,
      TopLink = _ref2.TopLink,
      CtaLinks = _ref2.CtaLinks;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      bonusRewards = _useState2[0],
      setBonusRewards = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showModule = _useState4[0],
      setShowModule = _useState4[1];

  var flags = useFlags();
  var ldClient = useLDClient();
  var releaseRedemptionEngineV2 = flags['releaseRedemptionEngineV2PromosDstr6078'] ? flags['releaseRedemptionEngineV2PromosDstr6078'] : false;
  useEffect(function () {
    var asyncEffect = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _loyaltyStorage$accou, loyaltyStorage;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setShowModule(false); // Wait for LaunchDarkly to initialize

                if (!ldClient) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return ldClient.waitForInitialization();

              case 4:
                _context.next = 7;
                break;

              case 6:
                return _context.abrupt("return");

              case 7:
                if (!(authenticationState === AuthenticationState.Authenticated && accountInfo)) {
                  _context.next = 12;
                  break;
                }

                loyaltyStorage = getLoyaltyStorage();

                if (!((loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou = loyaltyStorage.account) === null || _loyaltyStorage$accou === void 0 ? void 0 : _loyaltyStorage$accou.Status) === LoyaltyAccountStatus.Paused)) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return");

              case 11:
                getBonusRewards(releaseRedemptionEngineV2).then(function (response) {
                  if (response && (response === null || response === void 0 ? void 0 : response.length) >= 1) {
                    setBonusRewards(response);
                    setShowModule(true);
                  }
                }).catch(function (e) {
                  console.error("error", e.message);
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function asyncEffect() {
        return _ref3.apply(this, arguments);
      };
    }();

    asyncEffect();
  }, [authenticationState, accountInfo, releaseRedemptionEngineV2, ldClient]);
  return /*#__PURE__*/React.createElement(Fragment, null, showModule ? /*#__PURE__*/React.createElement("div", {
    className: "just-for-you-listing"
  }, /*#__PURE__*/React.createElement("div", {
    className: "just-for-you ".concat((bonusRewards === null || bonusRewards === void 0 ? void 0 : bonusRewards.length) > 3 ? "just-for-you--center" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "just-for-you__top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "just-for-you__header"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    field: Header,
    className: "just-for-you__header-txt"
  })), /*#__PURE__*/React.createElement("div", {
    className: "just-for-you__top-link"
  }, /*#__PURE__*/React.createElement(Link, {
    field: TopLink,
    className: "just-for-you__top-link-cta"
  }))), (bonusRewards === null || bonusRewards === void 0 ? void 0 : bonusRewards.length) > 3 ? /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 769,
    maxWidth: 1023
  }, /*#__PURE__*/React.createElement("div", {
    className: "just-for-you__reward-listing-slick"
  }, /*#__PURE__*/React.createElement(Carousel, {
    settings: {
      dots: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true
    }
  }, bonusRewards === null || bonusRewards === void 0 ? void 0 : bonusRewards.map(function (bonusReward, index) {
    if (index >= 5) return;
    return /*#__PURE__*/React.createElement(BonusRewardCard, {
      key: "bonus-reward-".concat(index),
      model: bonusReward === null || bonusReward === void 0 ? void 0 : bonusReward.fields,
      ctaLinks: CtaLinks,
      rewardBadge: (fields === null || fields === void 0 ? void 0 : fields.RewardBadge) || null,
      releaseRedemptionEngineV2: releaseRedemptionEngineV2
    });
  })))) : null, /*#__PURE__*/React.createElement("div", {
    className: "just-for-you__reward-listing"
  }, bonusRewards === null || bonusRewards === void 0 ? void 0 : bonusRewards.map(function (bonusReward, index) {
    if (index >= 5) return;
    return /*#__PURE__*/React.createElement(BonusRewardCard, {
      key: "bonus-reward-".concat(index),
      model: bonusReward === null || bonusReward === void 0 ? void 0 : bonusReward.fields,
      ctaLinks: CtaLinks,
      rewardBadge: (fields === null || fields === void 0 ? void 0 : fields.RewardBadge) || null,
      releaseRedemptionEngineV2: releaseRedemptionEngineV2
    });
  })))) : null);
};

var mapStateToProps = function mapStateToProps(state) {
  return {};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getBonusRewards: function getBonusRewards(releaseRedemptionEngineV2) {
      return dispatch(rewardsOperations.handleGetBonusRewards(releaseRedemptionEngineV2));
    },
    getBonusRewardsAccountInfo: function getBonusRewardsAccountInfo(accountInfo) {
      return dispatch(rewardsOperations.handleGetBonusRewardsAccountInfo(accountInfo));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(JustForYouListing);